import React, {
  FC,
  ReactElement,
  ButtonHTMLAttributes,
  ReactNode,
} from 'react';
import clsx from 'clsx';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'default' | 'small' | 'micro';
  children: ReactNode;
  disabled?: boolean;
  className?: string;
  logo?: ReactElement;
  variant?: 'default' | 'withLogo' | 'inverted' | 'danger';
  hasShadow?: boolean;
}

const Button: FC<ButtonProps> = ({
  size = 'default',
  children,
  disabled = false,
  className = '',
  logo,
  variant = 'default',
  hasShadow = true,
  ...props
}) => {
  return (
    <button
      className={clsx(
        'flex items-center text-semiBold rounded-small font-semibold',
        // Button sizes
        {
          'p-1 text-micro': size === 'micro',
          'px-3 py-1': size === 'small',
          'px-3 py-1.5': size === 'default',
        },
        // Variants
        {
          'bg-black text-white justify-center': variant === 'default',
          'bg-black text-white text-left w-logoButtonWidth h-logoButtonHeight max-w-full justify-left':
            variant === 'withLogo',
          'bg-white text-black justify-center': variant === 'inverted',
          'bg-transparent text-red border-[1px] border-red justify-center':
            variant === 'danger',
        },
        // Disabled / Enabled state
        { 'cursor-default opacity-40': disabled },
        // Shadow
        { 'shadow-default': hasShadow },
        className
      )}
      {...props}
      disabled={disabled}
    >
      {logo && <div className="mr-2">{logo}</div>} {children}
    </button>
  );
};

export default Button;
